<template>
    <div>
        <div class="empty"></div>
        <div class="position-absolute bottom" style="left: 37%"><h3>空空如也</h3></div>
    </div>
</template>

<script>
export default {
    name: "EmptyData"
}
</script>

<style scoped>

.empty {
    background: url("../../../assets/images/empty.png") no-repeat;
    background-size: 100% 100%;
    width: 334px;
    height: 334px;
}

</style>
